import { eventChannel as L, runSaga as I } from "redux-saga";
import * as e from "redux-saga/effects";
import * as t from "typed-redux-saga";
const i = e.takeEvery, u = e.takeLatest, r = t.put, f = e.delay, p = e.race, d = t.fork, y = t.select, n = t.take, k = t.call, m = t.cancel, h = t.getContext, A = t.cancelled, E = e.all;
function* C(c) {
  try {
    return { success: !0, ...yield yield* r(c) };
  } catch {
    return { success: !1 };
  }
}
let o = !1, s = "AUTHENTICATION_COMPLETED";
function* x(c) {
  c && (s = c), yield n(s), o = !0;
}
function* T() {
  o || (yield n(s));
}
export {
  E as all,
  C as api,
  k as call,
  m as cancel,
  A as cancelled,
  f as delay,
  L as eventChannel,
  d as fork,
  h as getContext,
  r as put,
  p as race,
  I as runSaga,
  y as select,
  n as take,
  i as takeEvery,
  u as takeLatest,
  x as trackAuth,
  T as waitForAuth
};
//# sourceMappingURL=saga-ts.es.js.map
